export default __webpack_public_path__ + "static/media/xml.4eb39de7.svg";